import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-notie-letter',
  templateUrl: './notie-letter.component.html',
  styleUrls: ['./notie-letter.component.css']
})
export class NotieLetterComponent implements OnInit {
  NType: string;
  AppId: any;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  PrintNoticeList: any;
  ProjectID: any;
  NotificationID: any;
  Type:any;
  notificationDetails:any={};
  today:any;
  ngOnInit() {
    debugger;
    this.route.params.subscribe(params => {
      this.AppId=params['AppId'];
      this.NotificationID = params['NotificationID'];
      this.ProjectID = params['ProjectID'];
      this.Type = params['Type'];
    })
    this.GetNoticeLetter(this.AppId,this.NotificationID,this.ProjectID,this.Type);
  }

  myFunction(){
    window.print();
  }
  GetNoticeLetter(AppId,NotificationID,ProjectID,Type){
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetNoticeLetter(AppId,NotificationID,ProjectID,Type)
      .subscribe(
        (response:any) => {
        this.PrintNoticeList=response;
        if(Type==1){this.NType='I'}else if(Type==2){this.NType='II'}else if(Type==3){this.NType='III'}
        this.today = new Date();
    //     this.Response.forEach(function (value, key) {
    //       value.Reservations.forEach(function (value1, key1) {
    //         value1.AllotedList.forEach(function (value2, key2) {
    //       x=value2.AllotmentLetterModel;
    //       this.AllotmentLetterModel.push(x);
    //     }.bind(this));
    //   });
    // });
    
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/pdf-forms/notie-letter/notie-letter.component.ts